import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import MuiPaper from '@material-ui/core/Paper';
import MuiTypography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import MissionControlSequenceBarContainer from './SequenceBar/Container';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(1.5),
  },
  sequenceBar: {
    width: '100%',
    flexGrow: 1,
  },
  title: {
    fontWeight: theme.typography.fontWeightMedium,
  },
});

function Widget({ className, classes, ...rest }) {
  return (
    <MuiPaper className={classNames(classes.root, className)} elevation={1}>
      <MuiTypography className={classes.title} color="primary" variant="h4">
        {'Mission Control'}
      </MuiTypography>
      <MissionControlSequenceBarContainer
        className={classes.sequenceBar}
        {...rest}
      />
    </MuiPaper>
  );
}

Widget.defaultProps = {
  className: '',
};

Widget.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Widget);
